/**
 * Formatear fechas de manera amigable
 */

/**
 * Convertir timestamp de Firestore a fecha legible
 * @param {object} timestamp - Timestamp de Firestore
 * @returns {string} - Fecha formateada
 */
export const formatPostDate = (timestamp) => {
  if (!timestamp) return '';
  
  try {
    // Si es un timestamp de Firestore
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    const now = new Date();
    const diffInMs = now - date;
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInWeeks = Math.floor(diffInDays / 7);
    const diffInMonths = Math.floor(diffInDays / 30);
    const diffInYears = Math.floor(diffInDays / 365);

    // Hace menos de 1 minuto
    if (diffInSeconds < 60) {
      return 'Ahora';
    }
    
    // Hace menos de 1 hora
    if (diffInMinutes < 60) {
      return `Hace ${diffInMinutes}m`;
    }
    
    // Hace menos de 24 horas
    if (diffInHours < 24) {
      return `Hace ${diffInHours}h`;
    }
    
    // Hace menos de 7 días
    if (diffInDays < 7) {
      return `Hace ${diffInDays}d`;
    }
    
    // Hace menos de 4 semanas
    if (diffInWeeks < 4) {
      return `Hace ${diffInWeeks}sem`;
    }
    
    // Hace menos de 12 meses
    if (diffInMonths < 12) {
      return `Hace ${diffInMonths}mes`;
    }
    
    // Hace más de 1 año
    return `Hace ${diffInYears}a`;
  } catch (error) {
    console.error('Error al formatear fecha:', error);
    return '';
  }
};

/**
 * Formatear fecha completa (para tooltips o detalles)
 * @param {object} timestamp - Timestamp de Firestore
 * @returns {string} - Fecha formateada completa
 */
export const formatFullDate = (timestamp) => {
  if (!timestamp) return '';
  
  try {
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    console.error('Error al formatear fecha completa:', error);
    return '';
  }
};
